export const telefon = "+46 303 70 72 31";
export const email = "kontakt@kbscenter.se";
export const instagramUrl = "https://www.instagram.com/kungalv.center/?hl=en";
export const facebookUrl = "https://www.facebook.com/kungalvbilcenter";
export const tiktokUrl = "https://www.tiktok.com/@kbscenter6";
export const address = (
  <>
    <p>
      Filaregatan 6, 44234 <br />
      Kungälv
    </p>
  </>
);
